// src/redux/actions/siteActions.js
export const SET_FEATURE_ACCESS = 'SET_FEATURE_ACCESS';

export const setFeatureaccess = (featureaccess) => ({
  type: SET_FEATURE_ACCESS,
  payload: featureaccess,
});
